(function(_s) {
    const SPLIDE_CDN_URL = 'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js';

    // Native script loader
    function loadScript(src) {
        return new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = src;
            script.onload = () => resolve();
            script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
            document.head.appendChild(script);
        });
    }

    // Gallery Splide initialization
    _s.fn.galleryInit = function() {
        return this.each(el => {
            const _self = _s(el);

            const defaultConfig = {
                type: "loop",
                perPage: 4,
                perMove: 1,
                speed: 800,
                gap: "0px",
                arrows: true,
                pagination: true,
                autoplay: false,
                breakpoints: {
                    768: {
                        arrows: false,
                    }
                }
            };

            const slideCount = _self.find('.splide__slide').length;
            
            // Only show controls if more than one slide
            if (slideCount <= 1) {
                defaultConfig.arrows = false;
                defaultConfig.pagination = false;
                defaultConfig.drag = false;
            }

            const splideInstance = new Splide(el, defaultConfig);

            splideInstance.on('mounted', () => {
                _self.addClass('is-initialized');
            });

            splideInstance.mount();
        });
    };

    // Initialize gallery carousels when document is ready
    _s(document).ready(() => {
        const galleryCarousels = _s('.gallery-container[data-display="carousel"] .splide');
        
        if (galleryCarousels.el.length) {
            loadScript(SPLIDE_CDN_URL)
                .then(() => {
                    galleryCarousels.galleryInit();
                })
                .catch(error => {
                    // console.error('Failed to load Splide library for gallery:', error);
                });
        }
    });
})(window._s);
